import { render } from "./NewCompany.vue?vue&type=template&id=47e19c77&scoped=true"
import script from "./NewCompany.vue?vue&type=script&lang=js"
export * from "./NewCompany.vue?vue&type=script&lang=js"

import "./NewCompany.vue?vue&type=style&index=0&id=47e19c77&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e19c77"]])

export default __exports__